export const isValidDate = (date: number): boolean => {
  return typeof date === "number" && !isNaN(date) && !isNaN(new Date(date).getTime());
};
